// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../public/assets/images/tower-game/3columns-normal-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../../public/assets/images/tower-game/3columns-success-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../../public/assets/images/tower-game/3columns-safe-tile-after-result.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../../public/assets/images/tower-game/3columns-adv-hightlighted-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../../../public/assets/images/tower-game/3columns-mine-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../../../public/assets/images/tower-game/3columns-X2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../../../public/assets/images/tower-game/3columns-X5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../../../public/assets/images/tower-game/3columns-X10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../../../public/assets/images/tower-game/3columns-active-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../../../../public/assets/images/tower-game/2columns-normal-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../../../../public/assets/images/tower-game/2columns-success-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../../../../public/assets/images/tower-game/2columns-safe-tile-after-result.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../../../../public/assets/images/tower-game/2columns-adv-highlighed-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../../../../../public/assets/images/tower-game/2columns-mine.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../../../../../public/assets/images/tower-game/2columns-X2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../../../../../public/assets/images/tower-game/2columns-X5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../../../../../public/assets/images/tower-game/2columns-X10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../../../../../public/assets/images/tower-game/2columns-active-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../../../../../public/assets/images/tower-game/tower-normal-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../../../../../public/assets/images/tower-game/tower-safe-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../../../../../public/assets/images/tower-game/tower-safe-tile-after-result.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../../../../../public/assets/images/tower-game/tower-adv-highlighed-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../../../../../public/assets/images/tower-game/tower-mine-tile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../../../../../public/assets/images/tower-game/X2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../../../../../public/assets/images/tower-game/X5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../../../../../public/assets/images/tower-game/X10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../../../../../public/assets/images/tower-game/tower-active-tile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tower-game-container {
  max-width: 428px;
  margin: 0 auto;
  border-radius: 12px;
  background-color: #333744;
  padding: 8px;
}
.tower-game-container .bet-modal-parent {
  height: 100%;
  display: flex;
  inset: 0;
  justify-content: center;
  align-items: center;
}
.tower-game-container .bet-modal-parent .bet-modal {
  border: 2px solid #06ab06;
  background: #051438;
  border-radius: 12px;
  padding: 0.5rem 1.5rem;
  height: auto;
  text-align: center;
}
.tower-game-container .play-btn-container button {
  border: 0;
  border-radius: 10px;
}
.tower-game-container .play-btn-container .play-btn {
  background: var(--pixi-active-103);
  border-color: var(--pixi-active-103);
  color: var(--white);
  min-height: 51px;
  color: var(--white);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.tower-game-container .play-btn-container .info-modal {
  min-width: 60px;
  background-color: var(--pixi-addon-105);
}
.tower-game-container .play-btn-container .info-modal img {
  width: 20px;
}
.tower-game-container .bet-calculation input {
  min-height: 44px;
  background-color: #051438;
  color: var(--white);
  padding: 10px 0 10px 50px;
  border: none;
  width: 100%;
}
.tower-game-container .bet-calculation .coin-icon {
  width: 20px;
  left: 10px;
  top: 25%;
}
.tower-game-container .bet-calculation .calculation-btn button {
  border: 0;
  border-radius: 5px;
  background: var(--pixi-addon-105);
  border-color: var(--pixi-addon-105);
  color: var(--white);
  min-width: 50px;
  min-height: 44px;
  font-size: 28px;
  font-weight: bold;
}
@media screen and (max-width: 991.98px) {
  .tower-game-container {
    margin-bottom: 1rem;
  }
}
.tower-game-container .grid-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  position: relative;
  padding: 4px 0;
  border-radius: 8px;
}
.tower-game-container .grid-section.extreme, .tower-game-container .grid-section.medium {
  grid-template-columns: repeat(3, 1fr);
}
.tower-game-container .grid-section.extreme .tile, .tower-game-container .grid-section.medium .tile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.tower-game-container .grid-section.extreme .tile.success, .tower-game-container .grid-section.medium .tile.success {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.tower-game-container .grid-section.extreme .tile.success-fade, .tower-game-container .grid-section.medium .tile.success-fade {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.tower-game-container .grid-section.extreme .tile.advance-highlight, .tower-game-container .grid-section.medium .tile.advance-highlight {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.tower-game-container .grid-section.extreme .tile.mine, .tower-game-container .grid-section.medium .tile.mine {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.tower-game-container .grid-section.extreme .tile.x2, .tower-game-container .grid-section.medium .tile.x2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.tower-game-container .grid-section.extreme .tile.x2.fade, .tower-game-container .grid-section.medium .tile.x2.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.extreme .tile.x5, .tower-game-container .grid-section.medium .tile.x5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.tower-game-container .grid-section.extreme .tile.x5.fade, .tower-game-container .grid-section.medium .tile.x5.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.extreme .tile.x10, .tower-game-container .grid-section.medium .tile.x10 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.tower-game-container .grid-section.extreme .tile.x10.fade, .tower-game-container .grid-section.medium .tile.x10.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.extreme .tile.active, .tower-game-container .grid-section.medium .tile.active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  cursor: pointer;
}
.tower-game-container .grid-section.extreme .tile.fade, .tower-game-container .grid-section.medium .tile.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.hard {
  grid-template-columns: repeat(2, 1fr);
}
.tower-game-container .grid-section.hard .tile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.tower-game-container .grid-section.hard .tile.success {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.tower-game-container .grid-section.hard .tile.success-fade {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.tower-game-container .grid-section.hard .tile.advance-highlight {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.tower-game-container .grid-section.hard .tile.mine {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.tower-game-container .grid-section.hard .tile.x2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.tower-game-container .grid-section.hard .tile.x2.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.hard .tile.x5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.tower-game-container .grid-section.hard .tile.x5.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.hard .tile.x10 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.tower-game-container .grid-section.hard .tile.x10.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.hard .tile.active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  cursor: pointer;
}
.tower-game-container .grid-section.hard .tile.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section.active {
  border: 2px solid #06ab06;
}
.tower-game-container .grid-section.active .multi-score {
  border: 2px solid #06ab06;
  border-bottom: 0;
}
.tower-game-container .grid-section.active .multiplier {
  position: absolute;
  right: 92%;
  top: -20px;
  font-size: 13px;
  margin-bottom: 0;
  padding: 0;
}
.tower-game-container .grid-section:not(:last-child) {
  margin-bottom: 0.6rem;
}
.tower-game-container .grid-section .tile {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}
.tower-game-container .grid-section .tile.success {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.tower-game-container .grid-section .tile.success-fade {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.tower-game-container .grid-section .tile.advance-highlight {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.tower-game-container .grid-section .tile.mine {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.tower-game-container .grid-section .tile.x2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.tower-game-container .grid-section .tile.x2.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section .tile.x5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.tower-game-container .grid-section .tile.x5.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section .tile.x10 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.tower-game-container .grid-section .tile.x10.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section .tile.active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  cursor: pointer;
}
.tower-game-container .grid-section .tile.fade {
  opacity: 0.5;
}
.tower-game-container .grid-section .multi-score {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -27px;
  gap: 24px;
  background: #051438;
  width: fit-content;
  padding: 5px 20px;
  border-radius: 20px 20px 0 0;
  z-index: 0;
  color: var(--White, #fff);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  min-width: 130px;
}
.tower-game-container .grid-section .multi-score img {
  width: 15px;
}`, "",{"version":3,"sources":["webpack://./src/games/TowerGame/components/Modals/FairnessModal/FairnessModal.scss"],"names":[],"mappings":"AAAA;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAAF;AAEE;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAAN;AAKI;EACE,SAAA;EACA,mBAAA;AAHN;AAMI;EACE,kCAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;AAOI;EACE,eAAA;EACA,uCAAA;AALN;AAOM;EACE,WAAA;AALR;AAWI;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;AATN;AAYI;EACE,WAAA;EACA,UAAA;EACA,QAAA;AAVN;AAcM;EACE,SAAA;EACA,kBAAA;EACA,iCAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAZR;AAiBE;EApFF;IAqFI,mBAAA;EAdF;AACF;AAgBE;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAdJ;AAgBI;EAEE,qCAAA;AAfN;AAiBM;EACE,yDAAA;AAfR;AAiBQ;EACE,yDAAA;AAfV;AAkBQ;EACE,yDAAA;AAhBV;AAmBQ;EACE,yDAAA;AAjBV;AAoBQ;EACE,yDAAA;AAlBV;AAqBQ;EACE,yDAAA;AAnBV;AAqBU;EACE,YAAA;AAnBZ;AAuBQ;EACE,yDAAA;AArBV;AAuBU;EACE,YAAA;AArBZ;AAyBQ;EACE,yDAAA;AAvBV;AAyBU;EACE,YAAA;AAvBZ;AA2BQ;EACE,yDAAA;EACA,eAAA;AAzBV;AA4BQ;EACE,YAAA;AA1BV;AA+BI;EACE,qCAAA;AA7BN;AA+BM;EACE,yDAAA;AA7BR;AA+BQ;EACE,0DAAA;AA7BV;AAgCQ;EACE,0DAAA;AA9BV;AAiCQ;EACE,0DAAA;AA/BV;AAkCQ;EACE,0DAAA;AAhCV;AAmCQ;EACE,0DAAA;AAjCV;AAmCU;EACE,YAAA;AAjCZ;AAqCQ;EACE,0DAAA;AAnCV;AAqCU;EACE,YAAA;AAnCZ;AAuCQ;EACE,0DAAA;AArCV;AAuCU;EACE,YAAA;AArCZ;AAyCQ;EACE,0DAAA;EACA,eAAA;AAvCV;AA0CQ;EACE,YAAA;AAxCV;AA6CI;EACE,yBAAA;AA3CN;AA6CM;EACE,yBAAA;EACA,gBAAA;AA3CR;AA8CM;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AA5CR;AAgDI;EACE,qBAAA;AA9CN;AAiDI;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,0BAAA;EACA,kCAAA;AAhDN;AAkDM;EACE,0DAAA;AAhDR;AAmDM;EACE,0DAAA;AAjDR;AAoDM;EACE,0DAAA;AAlDR;AAqDM;EACE,0DAAA;AAnDR;AAsDM;EACE,0DAAA;AApDR;AAsDQ;EACE,YAAA;AApDV;AAwDM;EACE,0DAAA;AAtDR;AAwDQ;EACE,YAAA;AAtDV;AA0DM;EACE,0DAAA;AAxDR;AA0DQ;EACE,YAAA;AAxDV;AA4DM;EACE,0DAAA;EACA,eAAA;AA1DR;AA6DM;EACE,YAAA;AA3DR;AA+DI;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA7DN;AA+DM;EACE,WAAA;AA7DR","sourcesContent":[".tower-game-container {\n\n  max-width: 428px;\n  margin: 0 auto;\n  border-radius: 12px;\n  background-color: #333744;\n  padding: 8px;\n\n  .bet-modal-parent {\n    height: 100%;\n    display: flex;\n    inset: 0;\n    justify-content: center;\n    align-items: center;\n\n    .bet-modal {\n      border: 2px solid #06ab06;\n      background: #051438;\n      border-radius: 12px;\n      padding: 0.5rem 1.5rem;\n      height: auto;\n      text-align: center;\n    }\n  }\n\n  .play-btn-container {\n    button {\n      border: 0;\n      border-radius: 10px;\n    }\n\n    .play-btn {\n      background: var(--pixi-active-103);\n      border-color: var(--pixi-active-103);\n      color: var(--white);\n      min-height: 51px;\n      color: var(--white);\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    .info-modal {\n      min-width: 60px;\n      background-color: var(--pixi-addon-105);\n\n      img {\n        width: 20px;\n      }\n    }\n  }\n\n  .bet-calculation {\n    input {\n      min-height: 44px;\n      background-color: #051438;\n      color: var(--white);\n      padding: 10px 0 10px 50px;\n      border: none;\n      width: 100%;\n    }\n\n    .coin-icon {\n      width: 20px;\n      left: 10px;\n      top: 25%;\n    }\n\n    .calculation-btn {\n      button {\n        border: 0;\n        border-radius: 5px;\n        background: var(--pixi-addon-105);\n        border-color: var(--pixi-addon-105);\n        color: var(--white);\n        min-width: 50px;\n        min-height: 44px;\n        font-size: 28px;\n        font-weight: bold;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    margin-bottom: 1rem;\n  }\n\n  .grid-section {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 4px;\n    position: relative;\n    padding: 4px 0;\n    border-radius: 8px;\n\n    &.extreme,\n    &.medium {\n      grid-template-columns: repeat(3, 1fr);\n\n      .tile {\n        background-image: url('../../../../../../public/assets/images/tower-game/3columns-normal-tile.png');\n\n        &.success {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-success-tile.png');\n        }\n\n        &.success-fade {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-safe-tile-after-result.png');\n        }\n\n        &.advance-highlight {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-adv-hightlighted-tile.png');\n        }\n\n        &.mine {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-mine-tile.png');\n        }\n\n        &.x2 {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-X2.png');\n\n          &.fade {\n            opacity: 0.5;\n          }\n        }\n\n        &.x5 {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-X5.png');\n\n          &.fade {\n            opacity: 0.5;\n          }\n        }\n\n        &.x10 {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-X10.png');\n\n          &.fade {\n            opacity: 0.5;\n          }\n        }\n\n        &.active {\n          background-image: url('../../../../../../public/assets/images/tower-game/3columns-active-tile.png');\n          cursor: pointer;\n        }\n\n        &.fade {\n          opacity: 0.5;\n        }\n      }\n    }\n\n    &.hard {\n      grid-template-columns: repeat(2, 1fr);\n\n      .tile {\n        background-image: url('../../../../../../public/assets/images/tower-game/2columns-normal-tile.png');\n\n        &.success {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-success-tile.png');\n        }\n\n        &.success-fade {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-safe-tile-after-result.png');\n        }\n\n        &.advance-highlight {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-adv-highlighed-tile.png');\n        }\n\n        &.mine {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-mine.png');\n        }\n\n        &.x2 {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-X2.png');\n\n          &.fade {\n            opacity: 0.5;\n          }\n        }\n\n        &.x5 {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-X5.png');\n\n          &.fade {\n            opacity: 0.5;\n          }\n        }\n\n        &.x10 {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-X10.png');\n\n          &.fade {\n            opacity: 0.5;\n          }\n        }\n\n        &.active {\n          background-image: url('../../../../../../public/assets/images/tower-game/2columns-active-tile.png');\n          cursor: pointer;\n        }\n\n        &.fade {\n          opacity: 0.5;\n        }\n      }\n    }\n\n    &.active {\n      border: 2px solid #06ab06;\n\n      .multi-score {\n        border: 2px solid #06ab06;\n        border-bottom: 0;\n      }\n\n      .multiplier {\n        position: absolute;\n        right: 92%;\n        top: -20px;\n        font-size: 13px;\n        margin-bottom: 0;\n        padding: 0;\n      }\n    }\n\n    &:not(:last-child) {\n      margin-bottom: 0.6rem;\n    }\n\n    .tile {\n      // background-color: #D9D9D9;\n      width: 100%;\n      height: 40px;\n      border-radius: 8px;\n      background-image: url('../../../../../../public/assets/images/tower-game/tower-normal-tile.png');\n      background-repeat: no-repeat;\n      background-size: 100% 100%;\n      background-position: center center;\n\n      &.success {\n        background-image: url('../../../../../../public/assets/images/tower-game/tower-safe-tile.png');\n      }\n\n      &.success-fade {\n        background-image: url('../../../../../../public/assets/images/tower-game/tower-safe-tile-after-result.png');\n      }\n\n      &.advance-highlight {\n        background-image: url('../../../../../../public/assets/images/tower-game/tower-adv-highlighed-tile.png');\n      }\n\n      &.mine {\n        background-image: url('../../../../../../public/assets/images/tower-game/tower-mine-tile.png');\n      }\n\n      &.x2 {\n        background-image: url('../../../../../../public/assets/images/tower-game/X2.png');\n\n        &.fade {\n          opacity: 0.5;\n        }\n      }\n\n      &.x5 {\n        background-image: url('../../../../../../public/assets/images/tower-game/X5.png');\n\n        &.fade {\n          opacity: 0.5;\n        }\n      }\n\n      &.x10 {\n        background-image: url('../../../../../../public/assets/images/tower-game/X10.png');\n\n        &.fade {\n          opacity: 0.5;\n        }\n      }\n\n      &.active {\n        background-image: url('../../../../../../public/assets/images/tower-game/tower-active-tile.png');\n        cursor: pointer;\n      }\n\n      &.fade {\n        opacity: 0.5;\n      }\n    }\n\n    .multi-score {\n      position: absolute;\n      left: 0;\n      right: 0;\n      margin: 0 auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      top: -27px;\n      gap: 24px;\n      background: #051438;\n      width: fit-content;\n      padding: 5px 20px;\n      border-radius: 20px 20px 0 0;\n      z-index: 0;\n      color: var(--White, #fff);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      min-width: 130px;\n\n      img {\n        width: 15px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
